import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './styles/App.css';
import { ChannelProvider } from './context/ChannelContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  // Check if admin is logged in
  const isAdmin = localStorage.getItem('streambd_admin') === 'true';

  return (
    <Router>
      <ChannelProvider>
        <div className="App">
          <Navbar isAdmin={isAdmin} />
          
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route 
              path="/admin/:day" 
              element={
                isAdmin ? <AdminDashboard /> : <Navigate to="/admin/login" />
              } 
            />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </ChannelProvider>
    </Router>
  );
}

export default App;